<template>
  <MainLayout>
    <Head title="Roles" />

    <template v-slot:header>Roles</template>

    <div class="mb-4" v-if="$can('roles.write')">
      <ButtonGroup>
        <Link :href="$route('roles.create')">Add Role</Link>
      </ButtonGroup>
    </div>

    <DataTable>
      <template v-slot:header>
        <th scope="col" class="">
          Name
        </th>
        <th scope="col">
          <span class="sr-only">Edit</span>
        </th>
      </template>

      <tr v-for="role in roles" :key="role.id">
        <td>{{ role.name }}</td>
        <td>
          <div class="flex gap-2 place-content-end">
            <button type="button"
                    class="text-red-600 hover:text-red-900"
                    v-if="$can('roles.write')"
                    @click="deleteRole(role)">Delete</button>
            <Link :href="$route('roles.edit', [role.id])" class="text-indigo-600 hover:text-indigo-900">Edit</Link>
          </div>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import PageComponent from '@/pages/page-component';
import DataTable from '@/components/data-table.vue'
import { Inertia } from '@inertiajs/inertia'
import UsesPermissions from '@/mixins/uses-permissions'

export default {
  mixins: [
    PageComponent,
    UsesPermissions,
  ],

  components: {
    DataTable,
    Link,
  },

  props: {
    roles: Object,
  },

  methods: {
    deleteRole(role) {
      if (confirm('Are you sure?')) {
        Inertia.delete(this.$route('roles.destroy', [role.id]))
      }
    }
  }
}
</script>
